exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-5b5d72de] {\n  margin: 0 auto;\n  max-width: var(--width);\n  display: grid;\n  grid-gap: var(--gap) 0;\n  grid-template: auto/repeat(var(--columns), 1fr);\n}\n@media (min-width: 980px) {\n.main[data-v-5b5d72de] {\n    grid-column-gap: var(--gap);\n}\n}", ""]);

// exports
